import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { UiLoadingIndicatorComponent } from '@common/ui/frontend-shared/loading-indicator';
import { AccessState, FeatureRouterLinkResolverService } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@core/frontend-shared";
import * as i3 from "@angular/common";
function MembershipProfileInfoboxComponent_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-message", 1);
    i0.ɵɵtext(1, " Ihr Zugang wurde noch nicht aktiviert, da noch keine Zahlung eingegangen ist. Bitte schlie\u00DFen Sie die Bestellung zuerst ab. Ist etwas schief gelaufen? Gerne hilft unser Supportteam weiter. ");
    i0.ɵɵelementStart(2, "button", 2);
    i0.ɵɵlistener("click", function MembershipProfileInfoboxComponent_Conditional_4_Conditional_0_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.payNow());
    });
    i0.ɵɵelementEnd()();
  }
}
function MembershipProfileInfoboxComponent_Conditional_4_Conditional_1_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-message", 4);
    i0.ɵɵtext(1, " Ihre Zugang l\u00E4uft in wenigen Tagen ab. Sie k\u00F6nnen die Mitgliedschaft schon jetzt verl\u00E4ngern, um die Plattform weiter benutzen zu k\u00F6nnen! ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 5);
    i0.ɵɵlistener("click", function MembershipProfileInfoboxComponent_Conditional_4_Conditional_1_Conditional_13_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.renew());
    });
    i0.ɵɵelementEnd();
  }
}
function MembershipProfileInfoboxComponent_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 3)(1, "tbody")(2, "tr")(3, "td");
    i0.ɵɵtext(4, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6, "g\u00FCltig");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "tr")(8, "td");
    i0.ɵɵtext(9, "Zugang g\u00FCltig bis");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "date");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵconditionalCreate(13, MembershipProfileInfoboxComponent_Conditional_4_Conditional_1_Conditional_13_Template, 3, 0);
  }
  if (rf & 2) {
    const status_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 2, status_r4.membership.validUntil));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(status_r4.membershipDaysLeft > 0 && status_r4.membershipDaysLeft < 10 ? 13 : -1);
  }
}
function MembershipProfileInfoboxComponent_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-message", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 6);
    i0.ɵɵlistener("click", function MembershipProfileInfoboxComponent_Conditional_4_Conditional_2_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.renew());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const status_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", !status_r4.hasExpiredMembership ? "Sie haben noch keine Mitgliedschaft." : "Ihre Mitgliedschaft ist abgelaufen. ", " Sie k\u00F6nnen eine neue Mitgliedschaft abschlie\u00DFen, um alle Inhalte sehen zu k\u00F6nnen. ");
  }
}
function MembershipProfileInfoboxComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MembershipProfileInfoboxComponent_Conditional_4_Conditional_0_Template, 3, 0, "ui-message", 1);
    i0.ɵɵconditionalCreate(1, MembershipProfileInfoboxComponent_Conditional_4_Conditional_1_Template, 14, 4);
    i0.ɵɵconditionalCreate(2, MembershipProfileInfoboxComponent_Conditional_4_Conditional_2_Template, 3, 1);
  }
  if (rf & 2) {
    const status_r4 = ctx;
    i0.ɵɵconditional(status_r4.membershipPaymentPending ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(status_r4.membershipIsValid ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!status_r4.membershipIsValid ? 2 : -1);
  }
}
export let MembershipProfileInfoboxComponent = /*#__PURE__*/(() => {
  class MembershipProfileInfoboxComponent {
    constructor(router, routerLinkResolver) {
      this.router = router;
      this.routerLinkResolver = routerLinkResolver;
      this.loggedIn$ = inject(Store).select(AccessState.loggedIn);
      this.membership$ = inject(Store).select(AccessState.accessData('membership'));
      this.hasExpiredMembership$ = inject(Store).select(AccessState.accessData('hasExpiredMembership'));
      this.membershipDaysLeft$ = inject(Store).select(AccessState.accessData('membershipDaysLeft'));
      this.membershipIsValid$ = inject(Store).select(AccessState.accessData('membershipIsValid'));
      this.membershipPaymentPending$ = inject(Store).select(AccessState.accessData('membershipPaymentPending'));
      this.membershipStatus$ = combineLatest({
        loggedIn: this.loggedIn$,
        membership: this.membership$,
        hasExpiredMembership: this.hasExpiredMembership$,
        membershipDaysLeft: this.membershipDaysLeft$,
        membershipIsValid: this.membershipIsValid$,
        membershipPaymentPending: this.membershipPaymentPending$
      });
    }
    payNow() {
      const registrationLink = this.routerLinkResolver.resolveRouterLink('membership-registration');
      this.router.navigate(registrationLink);
    }
    renew() {
      const registrationLink = this.routerLinkResolver.resolveRouterLink('membership-registration');
      this.router.navigate(registrationLink);
    }
    static {
      this.ɵfac = function MembershipProfileInfoboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembershipProfileInfoboxComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.FeatureRouterLinkResolverService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MembershipProfileInfoboxComponent,
        selectors: [["membership-profile-infobox"]],
        hostAttrs: ["e2e-membership-profile-infobox", "1"],
        decls: 6,
        vars: 6,
        consts: [[3, "loading"], ["type", "warn", 1, "membership-message", "message-payment-pending"], ["uiButton", "", "label", "Zahlung abschlie\u00DFen", 1, "ui-button-outline", "small", 3, "click"], [1, "ui-simpletable"], ["type", "info", 1, "membership-message", "message-expired"], ["uiButton", "", "label", "jetzt verl\u00E4ngern", 3, "click"], ["uiButton", "", "label", "Los gehts!", 3, "click"]],
        template: function MembershipProfileInfoboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2");
            i0.ɵɵtext(1, "Status Ihrer Mitgliedschaft");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "ui-loading-indicator", 0);
            i0.ɵɵpipe(3, "async");
            i0.ɵɵconditionalCreate(4, MembershipProfileInfoboxComponent_Conditional_4_Template, 3, 3);
            i0.ɵɵpipe(5, "async");
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("loading", !i0.ɵɵpipeBind1(3, 2, ctx.membershipStatus$));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_1_0 = i0.ɵɵpipeBind1(5, 4, ctx.membershipStatus$)) ? 4 : -1, tmp_1_0);
          }
        },
        dependencies: [CommonModule, UiLoadingIndicatorComponent, UiMessageComponent, UiButtonComponent, i3.AsyncPipe, i3.DatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MembershipProfileInfoboxComponent;
})();